import React, { useEffect, useState } from "react";
import {
  Card,
  Select,
  Button,
  Table,
  Input,
  Typography,
  message,
  Row,
  Col,
  Form,
} from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import { BASE_URL } from '../../App';
import axios from "axios";
import Swal from "sweetalert2";
import { Spin } from 'antd'
const { Title } = Typography;

const { Option } = Select;

const WindingWireApproval = () => {
  const [form] = Form.useForm();
  const [status, setStatus] = useState(null);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [ascType, setAscType] = useState(null);
  const [process, setProcess] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ascOptions, setAscOptions] = useState([]);
  const [statusHeader, setStatusHeader] = useState(null);
  const [statusapp, setstatusapp] = useState(null);
  const [types, setTypes] = useState([]);
  const generateExcelStyleLetters = () => {
    const letters = [];
    const ACode = "A".charCodeAt(0);
  
    for (let i = 0; i < 26; i++) {
      letters.push(String.fromCharCode(ACode + i)); 
    }
  
    for (let i = 0; i < 26; i++) {
      for (let j = 0; j < 26; j++) {
        const prefix = String.fromCharCode(ACode + i);
        const suffix = String.fromCharCode(ACode + j);
        letters.push(prefix + suffix); 
        if (prefix + suffix === "AZ") return letters; 
      }
    }
  
    return letters;
  };
  

  const login_id = localStorage.getItem("LOGIN_ID");
  const user_branch = localStorage.getItem("BRANCH_CODE");
  const usertype = localStorage.getItem("usertype");

  useEffect(() => {
    const fetchBranches = async () => {
      setLoading(true); 
      try {
        const response = await axios.post(BASE_URL + '/branchesforrewindingeateapproval', {
          user_branch: user_branch,
          login_id: login_id,
        });
        setBranches(response.data);
      } catch (error) {
        message.error("Failed to load branches");
      } finally {
        setLoading(false); 
      }
    };
  
    fetchBranches();
  }, []);
  


  const handleQtyChange = (value, index) => {
    const newData = [...data];
    newData[index].approvedQty = value;
    setData(newData);
  };
  const handleSubmit = async () => {
    if (!statusapp) {
      Swal.fire({
        icon: 'info',
        text: 'Please select Approval Status',
      });
      return;
    }
  
    try {
    
     setLoading (true);
  
      const response = await axios.post(BASE_URL + '/updateWindingWireFix', {
        statusapp: statusapp,
        data: data,
        branch: selectedBranch,
        dealercode: process,
        type: statusHeader,
        login_id: login_id
      });
  
      Swal.close(); 
  
      if (response.data.status_code === "200") {
        setLoading (false);
        Swal.fire({
          icon: 'success',
         // title: 'Success',
          text: response.data.message
        });
        setData([]);
        setTypes([]);
        setstatusapp(null);
      } else {
        setLoading (false);
        Swal.fire({
          icon: 'info',
        //  title: 'Error',
          text: response.data.message || "Rewinding Rate is not Updated !, Please Try Again"
        });
      }
    } catch (error) {
      console.error(error);
      //Swal.close(); 
      Swal.fire({
        icon: 'info',
        //title: 'Error',
        text: "Something went wrong. Please try again."
      });
    }
  };
  

  const handleReset = () => {
    form.resetFields();
    setStatus(null);
    setSelectedBranch(null);
    setAscType(null);
    setProcess(null);
    setData([]);
    setTypes([]);
    setstatusapp(null);
  };
  
  const handleStatusColumnSelect = (value) => {
    const updated = data.map((item) => ({
      ...item,
      status: value,
    }));
    setData(updated);
  };
  
  const columns = [
    {
      title: "Dealer Name",
      dataIndex: "dealerName",
      key: "dealerName",
    },
    {
      title: "Brand Name",
      dataIndex: "brandName",
      key: "brandName",
    },
    {
      title: "Requested Qty",
      dataIndex: "requestedQty",
      key: "requestedQty",
    },
    {
      title: "Approved Qty",
      dataIndex: "approvedQty",
      key: "approvedQty",
      render: (text, record, index) => (
        <Input
          type="number"
          min={0}
          value={record.approvedQty}
          onChange={(e) => handleQtyChange(e.target.value, index)}
          style={{ width: "100px" }}
        />
      ),
    },
  ];
  
useEffect(()=>{
setData([]);
setTypes([]);
setstatusapp(null);
},[process])
useEffect(() => {
  if (!ascType || !selectedBranch || !status) {
    setAscOptions([]);
    return;
  }

  const fetchServiceCenters = async () => {
    setLoading(true); 
    try {
      const response = await axios.post(BASE_URL + "/ascforrewidingfixapproval", {
        login_id: login_id,
        user_branch: user_branch,
        status: status,
        type: ascType,
        branch: selectedBranch
      });
      setAscOptions(response.data);
    } catch (error) {
      console.error("Error fetching ASC list", error);
    //  message.error("Failed to load service centers");
      setAscOptions([]);
    } finally {
      setLoading(false);
    }
  };

  fetchServiceCenters();
}, [ascType, selectedBranch, status]);

  useEffect(() => {
    setProcess(null);
    setData([]);
    setTypes([]);
    setstatusapp(null);
  }, [ascType, selectedBranch]);


  const handleStatusChange = async (value) => {
    setStatus(value);
    setAscOptions([]);
    setProcess(null);
    setBranches([]);
    setSelectedBranch(null);
    setAscType(null);
    setLoading(true); 
    setData([]);
        setTypes([]);
        setstatusapp(null);
    try {
      const response = await axios.post(BASE_URL + '/getbranchesbasedstatus', {
        login_id: login_id,
        user_branch: user_branch,
        status: value,
      });
  
      setBranches(response.data);
    } catch (error) {
      console.error("Failed to fetch branches:", error);
    //  message.error("Failed to load branches");
    } finally {
      setLoading(false); 
    }
  };
  
  const handleSearch = async () => {
    if (!selectedBranch ) {
      Swal.fire({
        icon: "info",
       // title: "Warning",
        text: "Please select branch",
      });
      return;
    }
    if (!process) {
      Swal.fire({
        icon: "info",
       // title: "Warning",
        text: "Please select service center",
      });
      
      return;
    }
    if ( !status) {
      Swal.fire({
        icon: "info",
       // title: "Warning",
        text: "Please select status",
      });
      
      return;
    }
  
    setLoading(true);
    try {
      const response = await axios.post(BASE_URL + "/rewindingrateforapprovals", {
        branch: selectedBranch,
        servicecentercode: process,
        status: status,
        login_id: login_id,
      });
  
      
      const rows = response.data.data.map((row, index) => ({
        key: index,
        ...row
      }));
      
      setData(rows);
      setTypes(response.data.types); 
      
    } catch (err) {
      console.error(err);
     // message.error("Failed to load fixation details");
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (index, field, value) => {
    
    let formattedValue = value.replace(/[^0-9.]/g, "");
  
    
    const parts = formattedValue.split(".");
    if (parts.length > 2) {
      formattedValue = parts[0] + "." + parts[1]; 
    }
  
    
    if (formattedValue.includes(".")) {
      const [intPart, decimalPart] = formattedValue.split(".");
      formattedValue = intPart + "." + decimalPart.slice(0, 2);
    }
  
    const newData = [...data];
    newData[index][field] = formattedValue;
    setData(newData);
  };
  const handleChange = async (value) => {
    setStatusHeader(value);
    setLoading(true); 
  
    try {
      const response = await axios.post(BASE_URL + '/rewindingratebasedontype', {
        type: value,
        data: data,
      });
  
      const rows = response.data.data.map((row, index) => ({
        key: index,
        ...row,
      }));
  
      setData(rows);
      console.log('API Response:', response.data);
    } catch (error) {
      console.error('Error making API call:', error);
    //  message.error("Failed to fetch rates");
    } finally {
      setLoading(false); 
    }
  };
  
  return (
    
    <div style={{ padding: "24px" }}>
       <style>
        {`
          .approved-select .ant-select-selector {
            background-color: #e6fffb !important;
            border-color: #52c41a !important;
            color: #08979c !important;
            font-weight: bold;
          }
          .rejected-select .ant-select-selector {
            background-color: #fff1f0 !important;
            border-color: #ff4d4f !important;
            color: #a8071a !important;
            font-weight: bold;
          }
        `}
      </style>
      {/* <Title level={3}>Winding Wire Fixation Approval</Title> */}

      <Card bordered style={{ marginBottom: 4 }}>
        <Form layout="vertical" form={form}>
          <Row gutter={16}>
            <Col xs={24} sm={12} md={6}>
            <Form.Item label="Status">
            <Select
  value={status}
  onChange={handleStatusChange}
>
  <Option value="APPROVED">APPROVED</Option>
  <Option value="REJECTED">REJECTED</Option>
  <Option value="YET TO BE APPROVED">YET TO BE APPROVED</Option>
</Select>

</Form.Item>

            </Col>
            <Col xs={24} sm={12} md={6}>
            <Form.Item label="Branch">
  <Select
    value={selectedBranch}
    onChange={setSelectedBranch}
    allowClear
    showSearch
    placeholder="Select Branch"
    optionFilterProp="label"
  >
    {branches.map((branch) => (
      <Option key={branch.value} value={branch.value} label={branch.label}>
        {branch.label}
      </Option>
    ))}
  </Select>
</Form.Item>

            </Col>
            <Col xs={24} sm={12} md={6}>
            <Form.Item label="ASC Type">
            <Select
  value={ascType}
  onChange={setAscType}
  allowClear
  placeholder="Select Type"
>
  <Select.Option value="CASC">CASC</Select.Option>
  <Select.Option value="DASC">DASC</Select.Option>
</Select>

</Form.Item>

            </Col>
            <Col xs={24} sm={12} md={6}>
            <Form.Item label="Service Center">
            <Select
  value={process}
  onChange={setProcess}
  allowClear
  placeholder="Select Service Center"
  
>
  {ascOptions.map((item) => (
    <Select.Option key={item.servicecentercode} value={item.servicecentercode}>
      {item.servicecentercode} - {item.servicecentername}
    </Select.Option>
  ))}
</Select>

</Form.Item>

            </Col>
          </Row>

          <Row justify="start" gutter={16}>
            <Col>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={handleSearch}
              >
                Search
              </Button>
            </Col>
            <Col>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                Reset
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>

      {data.length > 0 && (
  <Card bordered>
    <Table
      columns={[
        {
          title: "PSG",
          dataIndex: "PSG",
          key: "PSG",
        },
        {
          title: "Description",
          dataIndex: "PSGDESC",
          key: "PSGDESC",
        },
        {
          title: "HP",
          dataIndex: "HP",
          key: "HP",
        },
        {
          title: "Rate",
          dataIndex: "RATE",
          key: "RATE",
          render: (text, record, index) => (
            <Input
              type="number"
              step="0.01"
              min={0}
              value={record.RATE}
              onChange={(e) =>
                handleInputChange(index, "RATE", e.target.value)
              }
              style={{ width: "100px" }}
            />
          ),
        },
        {
          title: "Wire Rate",
          dataIndex: "RATE_70",
          key: "RATE_70",
        },
        {
          title: "Labour Charge",
          dataIndex: "RATE_30",
          key: "RATE_30",
        },
        {
          title: "Fixed Rate",
          dataIndex: "FIXED_RATE",
          key: "FIXED_RATE",
          render: (text, record, index) => (
            <Input
              type="number"
              step="0.01"
              min={0}
              value={record.FIXED_RATE}
              onChange={(e) =>
                handleInputChange(index, "FIXED_RATE", e.target.value)
              }
              style={{ width: "100px" }}
            />
          ),
        },
        {
          title: (
            <Select
            placeholder="Select Type"
            style={{ width: 100 }}
            value={statusHeader}
            onChange={handleChange}
          >
              <Option value=""></Option> 
  {types.map((t) => (
    <Option key={t.type} value={t.type}>
      {t.type}
    </Option>
  ))}
            </Select>
          ),
          dataIndex: "status",
          key: "status",
          render: () => statusHeader,
        },
      ]}
      dataSource={data}
      // loading={loading}
      pagination={false}
      //scroll={{ x: "max-content" }}
      scroll={{ y: 200 }}
      sticky
    />


<div
  style={{
    marginTop: 24,
    textAlign: "center",
    background: "#fff",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    display: "inline-block",
  }}
>
<Select
  placeholder="Approval Status"
  value={statusapp}
  onChange={setstatusapp}
  className={
    statusapp === "APPROVED"
      ? "approved-select"
      : statusapp === "REJECTED"
      ? "rejected-select"
      : ""
  }
  style={{ width: 200, marginRight: 16 }}
>
  <Option value="APPROVED">APPROVED</Option>
  <Option value="REJECTED">REJECTED</Option>
</Select>


  <Button type="primary" icon={<CheckCircleOutlined />} onClick={handleSubmit}>
    UPDATE
  </Button>
</div>


  </Card>
)}
 {loading && (
  <div style={{
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.6)', 
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}>
    <Spin tip="Loading PSGs..." size="large" />
  </div>
)}
    </div>
  );
};

export default WindingWireApproval;
